import PropTypes from 'prop-types';

const ReservationShape = PropTypes.arrayOf(PropTypes.shape({
  available: PropTypes.arrayOf(PropTypes.shape({
    hasAddOns: PropTypes.bool,
    hasMenus: PropTypes.bool,
    isGda: PropTypes.bool,
    serviceTypeId: PropTypes.number,
    serviceTypeKey: PropTypes.string,
    serviceTypeName: PropTypes.string,
    templateId: PropTypes.number,
    time: PropTypes.string,
    token: PropTypes.string,
    type: PropTypes.string,
  })),
  serviceTypeId: PropTypes.number,
  serviceTypeKey: PropTypes.string,
  serviceTypeName: PropTypes.string,
}));

export default ReservationShape;
